import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import api from "../utils/ApiMethod";

export const WhatNew = () => {
  const [data, setData] = useState([]);

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/get/marquees");
      setData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <div>
      {/* these css is written in  common.css*/}
      <div className="whatsNew-section">
        <div className="container">
          <div className="whatsNew-content">
            <h4
              className="whatsnew-heading"
              style={{ backgroundColor: "#016938" }}
            >
              <a
                href="whatsNewinner"
                className="whatsnew-link"
                title="Click here to View What's New Details "
              >
                Highlights
              </a>
            </h4>

            <div className="whatsNew-list-inner">
              {data.length > 0 && (
                <Marquee pauseOnHover={true} style={{ width: "100%" }}>
                  <ul
                    className="whatsNew-list"
                    style={{ alignItems: "center" }}
                  >
                    {data.map((elem, index) => (
                      <li key={index}>
                        <a
                          href={elem.documentlnk ? elem.documentlnk : "#"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>
                            {elem?.newest === true ? (
                              <img
                                src="img/new-blink-image.gif"
                                style={{
                                  height: "35px",
                                  width: "35px",
                                  display: "inline",
                                }}
                                alt="blink"
                              />
                            ) : (
                              ""
                            )}
                          </span>
                          {elem?.noticeTitle}
                          <span style={{ margin: "0px 12px" }}></span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </Marquee>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
